export default __webpack_public_path__ + "static/media/img-0385-switzerland-half-face.33408ad6.png";